/**
 * Column widths are derived from the x positions of the header labels in Figma, which is
 * what visually aligns the rows underneath them. The trailing column flexes so the table
 * can fill wider viewports without the cells drifting apart.
 */
export const UPCOMING_TRIPS_GRID =
  '117px 153px 128px 109px 130px minmax(106px, 1fr)'

export const UPCOMING_TRIPS_INSET =
  'pl-[31px] pr-[20px]'

export const UPCOMING_TRIPS_MIN_WIDTH = 794